import { FC, ReactNode } from 'react'
import { Container } from 'components/container'
import { MusicButtons } from './styled'

type Props = {
  children: ReactNode
  link: string
}

export const MusicLinks: FC<Props> = ({ children, link }) => (
  <MusicButtons>
    <Container>
      <a href={link} target="_blank" rel="noreferrer">
        {children}
      </a>
    </Container>
  </MusicButtons>
)
